import { render } from "./BaseConfirmModal.vue?vue&type=template&id=56791028"
import script from "./BaseConfirmModal.vue?vue&type=script&lang=js"
export * from "./BaseConfirmModal.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import BaseIcon from "@/components/BaseIcon.vue";
script.components = Object.assign({}, { BaseIcon }, script.components);